import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import ConfirmationFaq from '../components/ConfirmationPage/ConfirmationFaq';
import ConfirmationPrintView from '../components/ConfirmationPage/ConfirmationPrintView';
import ConfirmationScreenView from '../components/ConfirmationPage/ConfirmationScreenView';

const ConfirmationPage = ({ route }) => {
  const { timestamp, veteranName } = useSelector(state => ({
    timestamp: state.form.submission?.response?.timestamp,
    veteranName: state.form.data.veteranFullName,
  }));

  return (
    <div className="vads-u-margin-bottom--2p5">
      <section className="screen-only">
        <ConfirmationScreenView
          name={veteranName}
          timestamp={timestamp}
          route={route}
        />
      </section>

      <section className="print-only">
        <ConfirmationPrintView name={veteranName} timestamp={timestamp} />
      </section>

      <ConfirmationFaq />

      <div className="vads-u-margin-y--4 screen-only">
        <va-link-action text="Go back to VA.gov" href="/" type="secondary" />
      </div>
    </div>
  );
};

ConfirmationPage.propTypes = {
  route: PropTypes.object,
};

export default ConfirmationPage;
